import React, { useEffect } from "react";

/**
 * DisambiguationPanel
 * - options: array of objects that represent possible matches
 * - onSelect(option) → return selected object
 * - ttsMessage: optional voice guidance
 */

const DisambiguationPanel = ({
  options = [],
  onSelect = () => {},
  ttsMessage = ""
}) => {
  
  // Auto-speak selection guidance (if provided)
  useEffect(() => {
    if (ttsMessage) {
      const utter = new SpeechSynthesisUtterance(ttsMessage);
      utter.rate = 1;
      window.speechSynthesis.speak(utter);
    }
  }, [ttsMessage]);

  if (!options || options.length === 0) return null;

  return (
    <div className="visitor-ai-disambiguation-card">
      <h3>🔍 Multiple possible matches found</h3>
      <p>Please select the correct one:</p>

      <div className="disambiguation-list">
        {options.map((opt, i) => (
          <div
            key={i}
            className="disambiguation-item"
            onClick={() => onSelect(opt)}
          >
            <strong>{opt.name || opt.visitor_name || opt.host_name}</strong>

            <ul className="disambiguation-meta">
              {opt.mobile ? <li>📞 {opt.mobile}</li> : null}
              {opt.email ? <li>✉️ {opt.email}</li> : null}
              {opt.company ? <li>🏢 {opt.company}</li> : null}
              {opt.host_name ? <li>👨‍💼 Host: {opt.host_name}</li> : null}
              {opt.visit_purpose ? <li>🎯 Purpose: {opt.visit_purpose}</li> : null}
              {opt.date_time ? <li>🕒 {opt.date_time}</li> : null}
            </ul>

            <button className="select-btn">Select</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DisambiguationPanel;
